// routes/AdminRoutes.tsx
import { Outlet } from "react-router-dom";

export default function AdminRoutes() {
  // Route protection temporarily removed
  return <Outlet />;
}